import { render, staticRenderFns } from "./NeedOrderList.vue?vue&type=template&id=5e2c6a03&scoped=true&"
import script from "./NeedOrderList.vue?vue&type=script&lang=js&"
export * from "./NeedOrderList.vue?vue&type=script&lang=js&"
import style0 from "./NeedOrderList.vue?vue&type=style&index=0&id=5e2c6a03&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e2c6a03",
  null
  
)

export default component.exports